import React from 'react';
import { useField } from 'formik';
// import { TFormikInput } from '../types';
import TextField from '@material-ui/core/TextField';
import {TFormikInput} from "../../form/formik/types";

const Input: React.FC<TFormikInput> = ({
                                         name,
                                         disabled = false,
                                         variant = 'outlined',
                                         multiline = false,
                                         rows = 1,
                                         ...rest
                                       }) => {
  const [field, meta] = useField(name);

  const inputProps = {
    ...rest.inputProps,
    placeholder: rest?.placeholder,
    disabled,
  };

  return (
    <TextField
      variant={variant}
      {...field}
      {...rest}
      inputProps={inputProps}
      error={meta.touched && !!meta.error}
      helperText={meta.touched && meta.error}
      disabled={disabled}
      multiline={multiline}
      rows={rows}
    />
  );
};

export default Input;
